import React, { FC, ReactNode } from 'react';

import {
  AllChanelsArrType,
  MetricListArrType,
  MetricObjType,
  MetricTypesArrType,
} from '@app/interfaces/pages-types/anatylics-metric.type';
import { EasyModal } from '@ui';
import { useGetClassifierSecondModelsListQuery } from '@app/store/api/metrics.api';

import { ClassifierSecondMetricForm } from './classifier-second-metric-form';

type HandleMetricModalBlockProps = {
  show: boolean;
  onClose: () => void;
  label: ReactNode;
  metric: MetricTypesArrType;
  metricSettings: MetricObjType;
  editModal: boolean;
  copyModal: boolean;
  metricList?: MetricListArrType[];
  allChannels?: AllChanelsArrType[];
};

const ClassifierSecondModalBlock: FC<HandleMetricModalBlockProps> = (props) => {
  const { show, onClose, label, allChannels, metric, editModal, metricSettings, copyModal } = props;
  const { data: classifierModels, isLoading } = useGetClassifierSecondModelsListQuery();
  if (isLoading) return <></>;
  return (
    <EasyModal
      show={show}
      label={label}
      // customLayer={90}
      isAutoClosable={false}
      withoutFooter
      onClose={onClose}
      variant="mediumW650"
    >
      <div className="h-full w-full  px-[20px]">
        <ClassifierSecondMetricForm
          allChannels={allChannels}
          copyModal={copyModal}
          editModal={editModal}
          metricSettings={metricSettings}
          classifierModels={classifierModels}
          metricType={metric}
          onClose={onClose}
        />
      </div>
    </EasyModal>
  );
};

export default ClassifierSecondModalBlock;
